var WidgetBanners = window.WidgetBanners = (function () {
    var WidgetBanners = function (container) {
        this.dom = {
            container: null,
            slides: [],
            linksContainer: null,
            links: [],
            slidesContainer: null,
        };

        this.timer = null;
        this.delay = 7500;
        this.activeIndex = 0;

        this.dom.container = container;

        this.dom.slides = container.find('[js-node="widget-banners-slide"]');
        this.dom.linksContainer = container.find(
            '[js-node="widget-banners-slides-links-container"]'
        );

        this.dom.slidesContainer = container.find(
            '[js-node="widget-banners-items-wrapper"]'
        );

        if (this.dom.slides.length > 1) {
            this.createLinks();
            this.setActiveSlide(0);
            this.startTimer();
        } else {
            this.dom.slides.eq(0).addClass('m-active');
            setInterval(() => {
                this.showCoefs(0);
                this.setActiveSlide(0);
            }, 4000);
        }

        this.bindUI();

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                if (!this.timer) this.startTimer();
            } else if (document.visibilityState === 'hidden') {
                if (this.timer) this.stopTimer();
            }
        });
    };

    WidgetBanners.prototype.dispose = function () {
        this.unbindUI();
    };

    WidgetBanners.prototype.pushMtmEvent = function (type) {
        document.dispatchEvent(
            new CustomEvent('mtmCustomEvent', {
                detail: {
                    id: 'd-i02-e9',
                    container: this.dom.container[0],
                    trigger: type,
                    index: this.activeIndex + 1,
                    slides: this.dom.slides.length,
                },
            })
        );
    };

    WidgetBanners.prototype.bindUI = function () {
        var self = this;

        self.dom.container.on(
            'click',
            '[js-node="widget-banners-slide-link"]',
            function () {
                self.handleEvent($(this).index());
                self.pushMtmEvent('pagination');
            }
        );

        self.dom.container.swipe({
            swipeRight: function () {
                if (self.activeIndex !== 0) {
                    self.handleEvent(self.activeIndex - 1);
                    self.pushMtmEvent('swipe');
                }
            },
            swipeLeft: function () {
                if (self.activeIndex !== self.dom.slides.length - 1) {
                    self.handleEvent(self.activeIndex + 1);
                    self.pushMtmEvent('swipe');
                }
            },
            allowPageScroll: 'none',
            threshold: 30,
        });
    };

    WidgetBanners.prototype.unbindUI = function () {
        app.console.log('unbind WidgetBanners');
    };

    WidgetBanners.prototype.handleEvent = function (newActiveIndex) {
        this.activeIndex = newActiveIndex;
        this.setActiveSlide(this.activeIndex);
        this.stopTimer();
        this.startTimer();
    };

    WidgetBanners.prototype.createLinks = function () {
        var self = this;

        self.dom.slides.each(function () {
            self.dom.linksContainer.append(
                '<li class="widget-banners__slide-link" js-node="widget-banners-slide-link"></li>'
            );
        });

        self.dom.links = self.dom.container.find(
            '[js-node="widget-banners-slide-link"]'
        );
    };

    WidgetBanners.prototype.showCoefs = function (i) {
        $('.widget-banners__event-info-wrapper').remove();
        if ($('.widget-banners__event-live').hasClass('m-show')) {
            $('.widget-banners__event-live').removeClass('m-show');
        }
        let slideItem = this.dom.slides.eq(i);
        let coefContainer = $(slideItem).next('.j-banner-event-info');

        const isClientCartEnabled =
            window?.globalAppSettings?.isClientCartEnabled;

        function isInCart(oId) {
            if (isClientCartEnabled) {
                return window.ClientCart.hasOutcome(Number(oId));
            }
            return BettingCart.hasItem(Number(oId));
        }

        if (coefContainer.length > 0) {
            let eventId = coefContainer.attr('data-event-id');
            let isLive = coefContainer.attr('data-event-is-live');

            const fetchUrl =
                slideItem.parent().data().apiUrl +
                `/api/event/banner/${eventId}?live=${isLive}`;

            fetch(fetchUrl, {
                headers: {
                    bb_appSource: slideItem.parent().data().apiSource,
                    'Content-Type': 'application/json; charset=utf-8',
                },
                method: 'GET',
            })
                .then((response) => {
                    if (response.ok) {
                        let result = response.json();

                        return result;
                    } else {
                        console.log('Something went wrong');
                        return {};
                    }
                })
                .then((data) => {
                    if (!data.eventId) return;
                    if (data.isLive) {
                        $('.widget-banners__event-live').addClass('m-show');
                    }
                    if (data.isActive) {
                        let html =
                            '<div class="widget-banners__event-info-wrapper">';
                        if (data.outcome1) {
                            let activeCoef = isInCart(data.outcome1.coefId)
                                ? 'm-active'
                                : '';
                            html += `
<a onclick="widgetsBanner.handleCoefClick(this); return false;"
                    data-eid=${data.eventId}
                    data-val=${data.outcome1.value}
                    data-aid="${data.outcome1.coefId}"
                    data-is-live="${data.isLive}"
                    data-oid="${data.outcome1.coefId}"
                    data-coefvalue="${data.outcome1.value.toFixed(2)}"
                    class="widget-banners__event-coef1 ${activeCoef}" ><span class="widget-banners__coef-sign">1</span>${window.Utils.displayCoefValue(
                                data.outcome1.value
                            )}</a>`;
                        } else {
                            html +=
                                '<div class="widget-banners__event-coef-empty"></div>';
                        }

                        if (data.outcomeX) {
                            let activeCoef = isInCart(data.outcomeX.coefId)
                                ? 'm-active'
                                : '';
                            html += `
<a onclick="widgetsBanner.handleCoefClick(this); return false;"
                    data-eid=${data.eventId}
                    data-val=${data.outcomeX.value}
                    data-aid="${data.outcomeX.coefId}"
                    data-is-live="${data.isLive}"
                    data-oid="${data.outcomeX.coefId}"
                    data-coefvalue="${data.outcomeX.value.toFixed(2)}"
                    class="widget-banners__event-coefX ${activeCoef}"><span class="widget-banners__coef-sign">X</span>${window.Utils.displayCoefValue(
                                data.outcomeX.value
                            )}</a>`;
                        } else {
                            html +=
                                '<div class="widget-banners__event-coef-empty"></div>';
                        }

                        if (data.outcome2) {
                            let activeCoef = isInCart(data.outcome2.coefId)
                                ? 'm-active'
                                : '';
                            html += `
    <a onclick="widgetsBanner.handleCoefClick(this); return false;"
                    data-eid=${data.eventId}
                    data-val=${data.outcome2.value}
                    data-aid="${data.outcome2.coefId}"
                    data-is-live="${data.isLive}"
                    data-oid="${data.outcome2.coefId}"
                    data-coefvalue="${data.outcome2.value.toFixed(2)}"
                    class="widget-banners__event-coef2 ${activeCoef}"><span class="widget-banners__coef-sign">2</span>${window.Utils.displayCoefValue(
                                data.outcome2.value
                            )}</a>`;
                        } else {
                            html +=
                                '<div class="widget-banners__event-coef-empty"></div>';
                        }

                        html += '</div>';
                        $(coefContainer).html(html);
                    }
                });
        }
    };

    WidgetBanners.prototype.setActiveSlide = function (i) {
        let slideItem = this.dom.slides.eq(i);
        this.showCoefs(i);
        this.dom.slides.removeClass('m-active');
        slideItem.addClass('m-active');

        if (this.dom.slides.length == 1) return;

        this.dom.links.removeClass('m-active');

        const currentLink = this.dom.links.eq(i);
        currentLink.addClass('m-active');

        var stepSize = this.dom.container.outerWidth() * i;

        this.dom.slides.css({
            transform: 'translateX(-' + stepSize + 'px)',
        });
    };

    WidgetBanners.prototype.startTimer = function () {
        var self = this;

        self.timer = setInterval(function () {
            if (self.dom.slides.length == 1) {
                self.showCoefs(0);
                return;
            }

            ++self.activeIndex;

            if (self.activeIndex == self.dom.slides.length)
                self.activeIndex = 0;

            self.setActiveSlide(self.activeIndex);
        }, self.delay);
    };

    WidgetBanners.prototype.stopTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
    };

    return WidgetBanners;
})();

var widgetsBanner = window.widgetsBanner = (function () {
    const isClientCartEnabled = window?.globalAppSettings?.isClientCartEnabled;

    function removeFromCart(oId) {
        if (isClientCartEnabled) {
            window.ClientCart.removeOutcome(Number(oId));
        } else {
            BettingCart.removeItem(oId);
        }
    }

    function addToCart(sData) {
        if (isClientCartEnabled) {
            window.ClientCart.addOutcome({
                oId: Number(sData.oId),
                eId: Number(sData.eId),
            });
        } else {
            BettingCart.addItem(sData);
        }
    }

    function isInCart(oId) {
        if (isClientCartEnabled) {
            return window.ClientCart.hasOutcome(Number(oId));
        }
        return BettingCart.hasItem(Number(oId));
    }

    var data = {
        widgets: [],
    };

    return {
        data: data,
        init: function () {
            $('[js-node="widget-banners"]').each(function () {
                var container = $(this);
                data.widgets.push(new WidgetBanners(container));
            });
        },
        dispose: function () {},
        handleCoefClick: function (a) {
            a = $(a);

            let coef = {
                oId: a.data().oid,
                aId: a.data().aid,
                val: a.data().val,
                eId: a.data().eid,
                isLive: a.data().isLive,
            };

            if (isInCart(coef.oId)) {
                removeFromCart(coef.oId);
                a.removeClass('m-active');
            } else {
                addToCart(coef);
                a.addClass('m-active');
            }
        },
    };
})();

$(function () {
    widgetsBanner.init();
});
